<alert type="danger" *ngFor="let error of errors">{{error}}</alert>
<div class="table-responsive" id="case-identity-search-result-table-wrapper-div" *ngIf="cases">
  <table id="case-identity-search-results-table"
         class="table full-width table-hover table-condensed table-nowrap">
    <thead id="case-identity-search-results-table-header">
      <tr>
          <th width="20%"><span class="field-code">J010</span>
              Juvenile 
              <span popover="Juvenile Names are in the format “LastName,FirstName,MiddleName,Suffix Prefix”. If the name matched is an alias it will be denoted with the prepended text “(Alias)”. For Case Number and NC-JOIN searches the Real Name of the Juvenile on the originating petition for the county will display." 
              popoverTitle="Juvenile"><i class="fa fa-info-circle"></i></span> 
          </th>
          <th width="20%"><span class="field-code">J011</span>
              NC-JOIN Number 
              <span popover="A unique seven digit number managed by the Department of Public Safety Juvenile Justice and assigned to each Juvenile which enters their system." 
              popoverTitle="NC-JOIN Number"><i class="fa fa-info-circle"></i></span> 
          </th>
          <th width="20%">
            <span class="field-code">J012 </span>Date of Birth 
            <span popover="The Juvenile’s Date of Birth as listed on the petition filed with the courts. Date of Birth is formatted as MM/DD/CCYY." 
            popoverTitle="Date Of Birth"><i class="fa fa-info-circle"></i></span>
          </th>
          <th width="20%">
              <span class="field-code">J013 </span>County<br> 
              <span class="field-code">J014 </span>Case Number 
              <span [popover]="popTemplateForCounty" popoverTitle="County and Case Number"><i class="fa fa-info-circle"></i></span>
          </th>          
          <th width="10%">
              Actions <span [popover]="popTemplateForAction" popoverTitle="Actions"><i class="fa fa-info-circle"></i></span> 
          </th>
      </tr>
    </thead>
    <tbody id="case-identity-search-results-table-tbody">
      <tr *ngFor="let case of cases; let i = index;"
          (click)="onViewCaseSelected(case.getCaseIdentifier())"
          [class.highlighted-bgcolor]="focusedRowNumber === i || isCaseLastViewed(case.getCaseIdentifier())"
          (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)"
          id ="{{'case-identity-search-results-row-' + i}}"
          tabindex="{{2000 + i*3}}">
        <td id ="{{'case-identity-search-results-row-' + i + '-party'}}"
            width="27%"
            title="Click for Case View">

           <div class="table-responsive scroll-hide-xy"> 
             <table class="full-width table-nowrap">
               <tr *ngIf="case.getJuvenileName()">
                 <td class="text-align-left">
                  <!-- <span *ngIf="case.isJuvenileAliasName()"><span class="field-code">V469.a </span>(Alias) </span> -->
                  <span class="field-code">V469 </span><span title="{{case.getJuvenileName()}}">{{case.getJuvenileName()}}</span>
                 </td>
               </tr>   
               <tr *ngIf="(case.getJuvenileAliasCount() == 1)">
               <td class="text-align-left name-subline-color" title="+{{case.getJuvenileAliasCount()}} alias"><span class="field-code">V485 </span>+{{case.getJuvenileAliasCount()}} Alias</td></tr>
               <tr *ngIf="(case.getJuvenileAliasCount() > 1)"><td class="text-align-left name-subline-color" title="+{{case.getJuvenileAliasCount()}} aliases"><span class="field-code">V485 </span>+{{case.getJuvenileAliasCount()}} aliases</td></tr>    
             </table>
           </div>
        </td>
        <td id ="{{'case-identity-search-results-row-' + i + '-in-regards-to'}}"
            width="27%" 
            title="Click for Case View">
            <div class="table-responsive scroll-hide-xy"> 
              <table class="full-width table-nowrap">
					<tr *ngIf="case.getNCJoinNumber()">
                 <td class="text-align-left">                  
                  <span class="field-code">V469 </span><span title="{{case.getNCJoinNumber()}}">{{case.getNCJoinNumber()}}</span>
                 </td>
               </tr> 
              </table>
            </div>
        </td>
        <td id ="{{'case-identity-search-results-row-' + i + '-judgment-indexed'}}"
            width="12%" 
            title="Click for Case View">
			<div class="table-responsive scroll-hide-xy"> 
              <table class="full-width table-nowrap">
					<tr *ngIf="case.getDateOfBirth()">
                 <td class="text-align-left">                  
                  <span class="field-code">V469 </span><span title="{{case.getDateOfBirth()}}">{{case.getDateOfBirth() | date:'MM/dd/yyyy'}}</span>
                 </td>
               </tr> 
              </table>
            </div>
		</td>
        <td id ="{{'case-identity-search-results-row-' + i + '-county-case-number'}}"
            width="12%" 
            (click)="case.isMoreCases() ? $event.stopPropagation(): true"
            title="Click for Case View"><span  title="{{case.getCaseCounty() + ' ' + case.getCaseNumber()}}">{{case.getCaseCounty()}} 
                <br>{{case.getCaseNumber()}} {{case.getCaseStatus()}}</span>
                <br> <div *ngIf="case.isMoreCases()"  >                    
                    <!-- <span id="{{'showMoreCases' + i}}" (click)="show(this.id);"><span  class="glyphicon glyphicon-plus glyphicon-percent-80"></span><span>Show {{ case.getMoreCases().length }} More Case(s) </span></span>
                    <span id="{{'hideMoreCases' + i}}" style="display:none;" (click)="hide(this.id);"><span class="glyphicon glyphicon-minus"></span><span>Hide {{ case.getMoreCases().length }} More Case(s)</span></span> -->
                    
                    <a id="{{'case-search-results-row-'+ i + '-case-pleadings-issues-show-lnk'}}"
                                  tabindex="{{1000 +i*5 +1}}"
                                  title="Click for showing More cases" (click)="case.showMoreCases()" *ngIf="!case.getMoreCasesFlag()">
                                  <span  class="glyphicon glyphicon-chevron-right glyphicon-percent-80"></span><span>Show {{ case.getMoreCases().length }} More Case(s) </span>
                               </a>
                               <a id="{{'case-search-results-row-'+ i + '-case-pleadings-issues-hide-lnk'}}"
                                  tabindex="{{1000 + i*5 + 2}}"
                                  title="Click for hiding more cases" (click)="case.hideMoreCases()" *ngIf="case.getMoreCasesFlag()">
                                  <span class="glyphicon glyphicon-chevron-right"></span><span>Hide {{ case.getMoreCases().length }} More Case(s)</span>
                               </a> <br>
                               <span  *ngFor="let moreCase of case.getMoreCases();">
                               <span  title="{{moreCase.getCaseCounty() + ' ' + moreCase.getCaseNumber()}}" *ngIf="case.getMoreCasesFlag()">{{moreCase.getCaseCounty()}} 
                                <br>{{moreCase.getCaseNumber()}} {{moreCase.getCaseStatus()}} <br><br></span></span>
                    </div>
            </td>   
        <td id ="{{'case-identity-search-results-row-' + i + '-actions'}}"
            width="10%"
            (click)="$event.stopPropagation()">
          <a id="{{'case-identity-search-results-row-'+ i + '-action-view-case-lnk'}}" 
             tabindex="{{2000 + i*3 + 1}}"
             title="Click for Case View" 
             (click)="onViewCaseSelected(case.getCaseIdentifier())"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)">
             <span class="glyphicon glyphicon-folder-open"></span><span> View Case</span></a><br>
          <br><br> <div *ngIf="case.isMoreCases()"  >
          <span  *ngFor="let moreCase of case.getMoreCases();let x = index;">
              <span *ngIf=" x > 0"><br /></span>

            <span  title="{{moreCase.getCaseCounty() + ' ' + moreCase.getCaseNumber()}}" *ngIf="case.getMoreCasesFlag()">
                <a id="{{'case-identity-search-results-row-'+ x+i + '-action-view-case-lnk'}}" 
             tabindex="{{2000 + x*3 +i+ 1}}"
             title="Click for Case View" 
             (click)="onViewCaseSelected(moreCase.getCaseIdentifier())"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)">
             <span class="glyphicon glyphicon-folder-open"></span><span> View Case</span></a><br><br>          
            </span></span>
            </div>
        </td>
      </tr>
     </tbody>
  </table>
</div>
<div *ngIf="requestIsInFlight" class="text-center">
  <i id="juvenile-search-spinner" class="fa fa-spinner fa-pulse fa-5x"></i>
</div>
<ng-template #popTemplateForCounty>
    <div class="popover-section">The Case County is the county where the case was issued.</div>
    <div class="popover-section">The Case File Number consists of ‘YY&lt;casetype&gt;######’</div>
    <div class="popover-section">where: </div>
    <div class="popover-section">YY – two-digit year when the juvenile first entered the county’s jurisdiction on any delinquency matter,</div>
    <div class="popover-section">&lt;casetype&gt; two character code for the type of case (i.e. ‘JB’ for Juvenile Delinquency),</div>
    <div class="popover-section">‘######’ - sequence number for case filed.</div>
    <div class="popover-section">Case Status is Open/Closed.</div>
</ng-template>
<ng-template #popTemplateForAction>
    <div class="popover-section">Click &lt;View Case&gt; to see the details on the case.</div>
    <!-- <div class="popover-section">Click &lt;Add To Cart&gt; to add the case to the cart for printing or emailing.</div> -->
</ng-template>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-search-results-table/juvenile-search-results-table.component.html